import { useEffect, useMemo } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { ChargingData } from "../../data/models/ChargingData";
import useProfileData from "../../hooks/useProfileData";
import useUserData from "../../hooks/useUserData";
import { planEV } from "../../assets/profile-steering/ProfileSteering";
import { getCookie } from "../../data/Cookies";
import { useHistory } from "react-router-dom";
import { getPrice, getEmissions } from "../../assets/profile-steering/PriceEmissions";
import { Chart } from "react-chartjs-2";

import {
    Chart as ChartJS,
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController,
    Filler,
} from 'chart.js';

ChartJS.register(
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Filler,
    Legend,
    Tooltip,
    LineController,
    BarController
);

export default function PlanGraph() {

    const context = useFormContext();
    const energy = useWatch({ control: context.control, name: "desiredEnergy" });
    const departure = useWatch({ control: context.control, name: "departure" });
    const mode = useWatch({ control: context.control, name: "mode" });
    const hour = departure.getHours();
    const minutes = departure.getMinutes();

    const { profileData, getProfileData } = useProfileData();
    const { userData, getUserData } = useUserData();

    let id = getCookie("id");

    useEffect(() => {
        getProfileData();
    }, [])

    useEffect(() => {
        getUserData(id);
    }, [id])


    // @ts-ignore
    let data = useMemo<ChargingData[]>(() =>
        // @ts-ignore
        planEV(energy, [hour, minutes], mode, profileData.desired_profile, profileData.intervals, userData.ev_powers).map(({ name, pv, charge}) => {
            // console.log(name,pv,charge)
            return {
                name: name,
                pv: pv / 1000.0,
                charge: charge / 1000.0
            };
        })
        , [energy, hour, minutes, mode, profileData, userData]);


    // Perform these action every time one of the dependencies changes
    useEffect(() => {
        context.setValue("price", getPrice(data));
        context.setValue("CO2", getEmissions(data));
        context.setValue("planning", data)
    }, [context, data])

    //ChartJS stuff
    
    const options =  {
        responsive: true,
        scales: {
            x: {
                grid: {
                    display:false
                }
            },
            y: {
                ticks: {
                    callback: function (value, index, ticks) {
                        return value + " kW";
                    }
                }
            }
        },
        plugins: {
           legend: {
            position: 'top' as const
           }
        }
    }

    const graphData = {
        datasets: [
            {   
                label: 'Energy Prediction',
                backgroundColor: '#77c768',
                data: data.map(
                    i => {
                        return {
                        x: i.name,
                        y: i.charge
                    }}
                ),
                borderRadius: 45,
                borderSkipped: false,
            },

            {   
                label: 'Solar Power',
                type: 'line' as const,
                fill: 'origin',
                borderColor: '#fed426',
                backgroundColor: '#fed42650',
                pointRadius: 0,
                data: data.map(
                    i => {
                        return {
                            x: i.name,
                            y: i.pv
                        }
                    }
                )
            }
        ]
    }
        
    return(
        <Chart type="bar" data={graphData} options={options} />
    )
}